import { combineReducers } from "redux";
import authReducer from "../auth";
import entities from "../entities";

export default combineReducers({
  entities,
  auth: authReducer,
});
